<h1 mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center" style="padding-top: 10px;">
  <div fxFlex>Compose a new broadcast</div>
  <button mat-icon-button [mat-dialog-close]="false" class="button-40">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<mat-dialog-content class="mat-typography">
  <div class="form-container">
    <div *ngIf="isLoading">
      <mat-progress-spinner style="margin: 50px auto" [strokeWidth]="3" mode="indeterminate" [diameter]="150"></mat-progress-spinner>
    </div>

    <form *ngIf="!isLoading" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
      <app-mat-text-input [formControl]="broadcastName" label="Broadcast name" name="name" [submitted]="submitted"></app-mat-text-input>

      <app-mat-recipients-multiselect [formControl]="contacts" [disabled]="false" [groups]="['Contacts']" label="Contacts"
                                      placeholder="Search for contacts">
      </app-mat-recipients-multiselect>

      <app-mat-recipients-multiselect [formControl]="tags" [disabled]="false" [groups]="['Tags']" label="Tags"
                                      placeholder="Search for tags">
      </app-mat-recipients-multiselect>

      <div>
        <mat-label class="label">
          Custom Contacts Filter
        </mat-label>
        <div class="holder-with-border">
          <app-grid-filter [initialQuery]="customContactsQuery" [filterOptions]="filterOptions" [readonly]="true" [hideSearchInput]="true" [disableUrlChanges]="true">
            <app-filter-second-row-additional-content>
              <button type="button" mat-stroked-button (click)="openContactsList($event)">Edit</button>
            </app-filter-second-row-additional-content>
          </app-grid-filter>
        </div>
      </div>

      <app-mat-text-input [formControl]="unsubscribeKeyword" label="Unsubscribe keyword" name="code" [submitted]="submitted"></app-mat-text-input>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="onSubmit()" [promiseBtn]="buttonSubmitPromise" cdkFocusInitial>Save</button>
</mat-dialog-actions>
